import { DataTable } from 'primereact/datatable';
import { Dialog } from 'primereact/dialog';
import React, { useEffect, useState } from 'react'
import { Fetch } from '../../../shared/Fetch';
import { Column } from 'primereact/column';
import { format } from 'date-fns';

interface IProps {
    singleData: any;
    open: boolean;
    load: boolean;
    hideDialog: () => void;
    toast: any;
}

export const POConsultantRateHistory = (props: IProps) => {
    const [rateHistory, setRateHistory] = useState([]);

    const loadPoConsultantRateHistory = async () => {
        let po_Id: number;
        po_Id = props.singleData?.pO_ID
        const response = await Fetch("vwPODetails/GetPoConsultantRateHistory", "GET", null, `po_ID=${po_Id}`, null);
        if (response) {
            const data = await response.json();
            setRateHistory(data)
        }
    }             

    useEffect(() => {
        if (props.load) {
            loadPoConsultantRateHistory();
        }
    }, [props.load])

    const formatDate = (rowData: any) => {
        let date;
        if (rowData.created_At) date = format(new Date(rowData.created_At), 'dd/MM/yyyy').toUpperCase();
        else date = "";
        return (<>{date}</>);
    };

    const formatTODate = (rowData: any) => {
        let date;
        if (rowData.to_Date) date = format(new Date(rowData.to_Date), 'dd/MM/yyyy').toUpperCase();
        else date = "";
        return (<>{date}</>);
    };

    const formFromdate = (rowData: any) => {
        let date;
        if (rowData.from_Date) date = format(new Date(rowData.from_Date), 'dd/MM/yyyy').toUpperCase();
        else date = "";
        return (<>{date}</>);
    };


    const onHide = () => {
        props.hideDialog();
    }
    return (
        <Dialog visible={props.open} style={{ width: '70vw', height: "40vh" }} header="PO Consultant Rate History" modal onHide={onHide} className="p-fluid">
            <div className='mt-2'>
                <DataTable
                    style={{ fontSize: "15px" }}
                    value={rateHistory}
                    lazy
                    dataKey="id"
                    size="small"
                    tableStyle={{ minWidth: "50rem", maxHeight: "3rem" }}
                    showGridlines
                >
                    <Column header="S.No." body={(rowData, options) => options.rowIndex + 1} />
                    <Column field="po_Id" header="PO ID" />
                    <Column field="bRate" header="Buying Rate " />
                    <Column field="sRate" header="Selling Rate" />
                    <Column field="mRate" header="Margin Rate" />
                    <Column field="prev_BRate" header="Previous Buying Rate" />
                    <Column field="prev_SRate" header="Previous Selling Rate" />
                    <Column field="prev_MRate" header="Previous Margin Rate" />
                    <Column field="created_By" header="Created By" />
                    <Column field="created_At" header="Created At" body={formatDate} />
                    <Column field="to_Date" header="To Date" body={formatTODate} />
                    <Column field="from_Date" header="From Date" body={formFromdate} />
                    <Column field="from_Date" header="From Date" body={formFromdate} />
                </DataTable>
            </div>
        </Dialog>

    )
}

